<script setup>
    import Invitation from '@/components/invitation/Invitation.vue';
</script>

<template>
    <div class="invitation__container custom-container big-wrapper">
        <Invitation />
    </div>
</template>

<style lang="scss" scoped>
    .invitation__container  {
        width: 100%;
        display: block;
    }

    @media (max-width: 576px) {
        .custom-container{
            padding: 25px;
            margin-top: 6dvh
        }    
    }

    //Tablets en modo vertical (de 577px a 1024px)
@media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
    .custom-container{
            padding: 25px;
            margin-top: 7dvh
        }    
}
</style>